import { connect } from 'react-redux';
import { Route as RouteComponent } from './route.component';
import { getUserData } from '../../authentication/authentication.actions';

export const Route = connect(sState => ({ sState }), {
  getUserData
})(RouteComponent);